// Single source of truth for "is this job overdue?" logic.
// Any code that needs to know whether a job is overdue, count overdue
// jobs, or filter a list down to overdue jobs MUST use these helpers.
//
// History: this file was extracted after we found the same predicate
// duplicated in 4 places (AppLayout, JobsPage banner, JobsPage URL filter,
// DashboardPage banner) with one of them missing 'approved' from the
// exclusion list. The result was a sidebar showing "4 overdue" while the
// jobs page banner showed "5 overdue" for the same data set.
// If you find yourself writing this predicate inline somewhere, stop and
// import from here instead.

/**
 * Statuses where a job is considered closed / done.
 * A job in any of these states is NEVER overdue, regardless of dates.
 */
export const TERMINAL_STATUSES = ['completed', 'approved', 'cancelled'];

/**
 * Bir iş "gecikmiş ve atanmamış" mı?
 *
 * Kuralları:
 * - status === 'pending' (atanmamış)
 * - due_at veya scheduled_at geçmiş (NOW'dan küçük)
 *
 * @param {object} job - Job nesnesi (status, due_at, scheduled_at içermeli)
 * @param {Date} [now=new Date()] - Karşılaştırma anı (test için override edilebilir)
 * @returns {boolean}
 */
export function isOverdueUnassigned(job, now = new Date()) {
  if (job.status !== 'pending') return false;
  const deadline = job.due_at || job.scheduled_at;
  if (!deadline) return false;
  return new Date(deadline) < now;
}

/**
 * Bir iş "gecikmiş ve atanmış" mı?
 *
 * Kuralları:
 * - status terminal değil (TERMINAL_STATUSES'da yok)
 * - status 'pending' değil (yani gerçekten atanmış)
 * - due_at veya scheduled_at geçmiş
 *
 * @param {object} job
 * @param {Date} [now=new Date()]
 * @returns {boolean}
 */
export function isOverdueAssigned(job, now = new Date()) {
  if (job.status === 'pending') return false;
  if (TERMINAL_STATUSES.includes(job.status)) return false;
  // Paused jobs are intentionally on hold (Sprint C.2). The user has actively
  // chosen to pause; "overdue" implies missed/forgotten, which is the wrong
  // signal here. The Beklemede card in JobDetail communicates the state.
  if (job.status === 'paused') return false;
  const deadline = job.due_at || job.scheduled_at;
  if (!deadline) return false;
  return new Date(deadline) < now;
}

/**
 * Bir iş "gecikmiş" mi (atanmış veya atanmamış fark etmeksizin)?
 * URL filter `?filter=overdue` için kullanılır.
 *
 * @param {object} job
 * @param {Date} [now=new Date()]
 * @returns {boolean}
 */
export function isOverdue(job, now = new Date()) {
  return isOverdueUnassigned(job, now) || isOverdueAssigned(job, now);
}
